export default "__VITE_ASSET__CXUhXMdN__"